import type { Props } from "../../core/types/tsx/components/order-detail/NotesCard.types";


export function NotesCard({ notes }: Props) {
  return (
    <section className="rounded-2xl bg-white p-6 soft-border">
      <p className="text-sm font-semibold text-gray-700 mb-2">Notas Adicionales</p>
      <p className="text-sm text-gray-700 leading-relaxed">{notes.text}</p>
    </section>
  );
}

export default NotesCard;
